import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environment';

const size = environment.maxFileSize || 5;
const MAX_FILE_SIZE = size * 1024 * 1024; // 2MB in bytes

export const fileSizeInterceptor: HttpInterceptorFn = (req, next) => {
    // Check if the request is a file upload
    if (req.body instanceof FormData) {
        const formData = req.body;

        for (const value of formData.values()) {
            if (value instanceof File) {
                if (value.size > MAX_FILE_SIZE) {
                    return throwError(() => ({
                        error: {
                            error: `File ${value.name} exceeds the maximum size limit of 2MB`,
                        },
                    }));
                }
            }
        }
    }

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 413) {
                // Payload Too Large
                return throwError(() => ({
                    error: {
                        error: {
                            error: 'The uploaded file is too large. Maximum size allowed is 2MB',
                        },
                    },
                }));
            }
            return throwError(() => error);
        })
    );
};
